(function () {
    'use strict';
    var controllerId = '4a_pcDatoreLavoroAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', 'datLavoro', 'corsoId', 'opInsert', 'settProfessionali', 'province', 'paesi', 'tIndirizzi', fn_4a_pcDatoreLavoroAdd]);

    function fn_4a_pcDatoreLavoroAdd($scope, $uibModalInstance, datacontext, datLavoro, corsoId, opInsert, settProfessionali, province, paesi, tIndirizzi) {
        //Localizzazione
        $scope.province = province;
        $scope.paesi = paesi;
        $scope.comuni = [];
        $scope.tIndirizzi = tIndirizzi;
        //***
        $scope.settProfessionali = settProfessionali;
        //Funzioni
        $scope.validCF_L = true;
        $scope.checkCF_L = checkCF_L;
        $scope.checkCF = checkCF;
        $scope.checkPIVA = checkPIVA;

        if (datLavoro) {
            $scope.record = jQuery.extend({}, datLavoro); //Clona oggetto.
            $scope.Title = 'Modifica Datore Lavoro (ID: ' + $scope.record.Id + ')';
            if (typeof $scope.record.CodiceFiscale != 'undefined' && $scope.record.CodiceFiscale != null && $scope.record.CodiceFiscale.length > 0) {
                checkCF($scope.record.CodiceFiscale);
            }
            if (typeof $scope.record.PartitaIVA != 'undefined' && $scope.record.PartitaIVA != null && $scope.record.PartitaIVA.length > 0) {
                checkPIVA($scope.record.PartitaIVA);
            }
            if ($scope.record.ProvinciaId > 0) {
                getComuni($scope.record.ProvinciaId);
            }
            if ($scope.record.TAtecoId > 0) {
                getAteco($scope.record.TAtecoId);
            }
        }
        else {
            $scope.Title = 'Nuovo Datore Lavoro';
            $scope.record = {};
            $scope.record.Id = 0;
            $scope.record.CNDCorsoId = corsoId;
            $scope.record.OpInsert = opInsert;
            $scope.record.Deleted = false;
            $scope.record.iVersion = 1;

            $scope.record.ComuneId = '';
            $scope.record.PaeseId = 0;
            $scope.record.TIndirizzoId = 1;
        }

        //Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
            $scope.dt = new Date();
        };
        $scope.today();

        $scope.clear = function () {
            $scope.dt = null;
        };

        // Disable weekend selection
        $scope.disabled = function (date, mode) {
            //return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        $scope.openCalendar = function ($event, iOpened) {
            console.log('openCalendar');
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = false;
            if (iOpened == 1) {
                console.log('iOpened == 1');
                $scope.opened1 = true;
            }

        };

        $scope.clear = function ($event, iOpened) {
            console.log('clear');
            if (iOpened == 1) {
                $scope.record.NascData = '';
                $scope.changed = true;
            }

        };

        $scope.format = "dd/MM/yyyy";



        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.record);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return item;
        }

        //Localizzazione
        $scope.change_Paesi = function () {
            if ($scope.record.PaeseId > 0) {
                $scope.record.ProvinciaId = 0;
                $scope.record.ComuneId = 0;
            }
        };

        $scope.change_Comuni = function (idprov) {
            //console.info('change_Comuni()', idprov);
            $scope.record.ComuneId = '';
            getComuni(idprov);
        };

        function getComuni(idprov) {
            //console.info('getComuni()', idprov);
            if (!idprov || idprov == 0) return $scope.comuni = [];

            if ($scope.record.ProvinciaId != idprov)
                $scope.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return $scope.comuni = data;
            });
        }


        

        // #region FUNZIONI DI SUPPORTO

        function getAteco(id) {
            if (!id) return;
            return datacontext.tAteco_get(id).then(function (data) {
                if (data != null)
                    $scope.record.searchTextAteco = data.Title;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- SUGGESTION PER CODICE ATECO -#-#-#-#-#-#
        //Define Suggestions List
        $scope.suggestionsAteco = [];
        $scope.suggestionsObjAteco = [];
        //Define Selected Suggestion Item
        $scope.selectedIndexAteco = -1;
        //Function To Call On ng-change
        $scope.searchAteco = function () {
            $scope.suggestionsAteco = [];
            $scope.suggestionsObjAteco = [];
            if ($scope.record.searchTextAteco == undefined) return;
            if ($scope.record.searchTextAteco.length < 5) return; //numero minimo di caratteri

            return datacontext.tAteco_getByText($scope.record.searchTextAteco).then(function (data) {
                //console.log(data);
                if (data) {
                    $scope.suggestionsAteco = [];
                    $scope.suggestionsObjAteco = data;
                    data.forEach(function (item) {
                        $scope.suggestionsAteco.push(item.Name);
                    });
                }
                if ($scope.suggestionsAteco.length == 1) {
                    $scope.AssignValueAndHideAteco(0);
                }
            });
        };
        //Keep Track Of Search Text Value During The Selection From The Suggestions List  
        $scope.$watch('selectedIndexAteco', function (val) {
            if (val !== -1 && typeof (val) != 'undefined') {
                $scope.record.searchTextAteco = $scope.suggestionsAteco[$scope.selectedIndexAteco];
                $scope.record.TAtecoId = $scope.suggestionsObjAteco[$scope.selectedIndexAteco].Id;
            }
        });
        //Reset Text of Ateco
        $scope.resetTextAteco = function () {
            if ($scope.record.TAtecoId > 0) {
                $scope.record.TAtecoId = '';
                $scope.validAteco = false;
                $scope.record.searchTextAteco = '';
            }
        };
        //Text Field Events
        //Function To Call on ng-keydown
        $scope.checkKeyDownAteco = function (event) {
            if (event.keyCode === 40) {//down key, increment selectedIndexAteco
                event.preventDefault();
                if ($scope.selectedIndexAteco + 1 !== $scope.suggestionsAteco.length) {
                    $scope.selectedIndexAteco++;
                }
            } else if (event.keyCode === 38) { //up key, decrement selectedIndexAteco
                event.preventDefault();
                if ($scope.selectedIndexAteco - 1 !== -1) {
                    $scope.selectedIndexAteco--;
                }
            } else if (event.keyCode === 13) { //enter key, empty suggestions array
                event.preventDefault();
                $scope.suggestionsAteco = [];
                $scope.suggestionsObjAteco = [];
            }
        };
        //Function To Call on ng-keyup
        $scope.checkKeyUpAteco = function (event) {
            if (event.keyCode !== 8 && event.keyCode !== 46) {//delete or backspace     			
                if ($scope.record.searchTextAteco == "") {
                    $scope.suggestionsAteco = [];
                    $scope.suggestionsObjAteco = [];
                }
            } else {
                if ($scope.record.TAtecoId > 0) {
                    $scope.record.TAtecoId = '';
                    $scope.record.searchTextAteco = '';
                }
            }
        };
        //======================================
        //List Item Events
        //Function To Call on ng-click
        $scope.AssignValueAndHideAteco = function (index) {
            //console.log('hide');
            $scope.record.searchTextAteco = $scope.suggestionsAteco[index];
            $scope.record.TAtecoId = $scope.suggestionsObjAteco[index].Id;
            $scope.suggestionsAteco = [];
            $scope.suggestionsObjAteco = [];
        };
        //======================================
        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- END -#-#-#-#-#-#


        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID PARTITA IVA -#-#-#-#-#-#
        $scope.validPIVA = true;
        function checkPIVA(value) {
            $scope.validPIVA = true;
            if (value == undefined) return;
            if (value.length != 11) return; //numero minimo di caratteri  
            $scope.validPIVA = false;
            return datacontext.validazione_piva(value, false).then(function (data) {
                return $scope.validPIVA = data;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID CODICE FISCALE -#-#-#-#-#-#
        $scope.validCF = true;       

        function checkCF(value) {
            $scope.validCF = true;
            var isEnte = false;
            if (value == undefined) return;
            if (value.length != 11 && value.length != 16) return; //numero minimo di caratteri  
            if (value.length == 11) isEnte = true;
            $scope.validCF = false;
            return datacontext.validazione_cf(value, isEnte).then(function (data) {
                return $scope.validCF = data;
            });
        }

        //Funzioni
        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID CODICE FISCALE -#-#-#-#-#-#
        function checkCF_L(_value) {
            $scope.validCF_L = true;
            if (_value == undefined) return;
            if (_value.length != 16) return;
            $scope.validCF_L = false;
            return datacontext.validazione_cf(_value, false).then(function (data) {
                //console.info('validazione_cf', _value, data);
                return $scope.validCF_L = data;
            });
        }

        // #endregion

    }
})();